import { createSelector } from '@reduxjs/toolkit';

import { selectDealType, selectOfferType } from 'shared/selectors/jsonQuery';
import { ISelectOption } from 'shared/types/filters';

import { EPriceType, FDealType, FOfferType } from '../../../../packages/JsonQuery';

const COWORKING_AND_WORKPLACE = FOfferType.Coworking | FOfferType.Workplace;

const COWORKING_OPTIONS: ISelectOption[] = [
  { label: 'за всё', value: EPriceType.Total },
  { label: 'за рабочее место', value: EPriceType.SM },
];

const SALE_LAND_OPTIONS: ISelectOption[] = [
  { label: 'за всё', value: EPriceType.Total },
  { label: 'за сотку', value: EPriceType.SM },
];

const RENT_LAND_OPTIONS: ISelectOption[] = [
  { label: 'за месяц', value: EPriceType.Total },
  { label: 'за сотку в год', value: EPriceType.SM },
];

const SALE_OPTIONS: ISelectOption[] = [
  { label: 'за всё', value: EPriceType.Total },
  { label: 'за м\u00B2', value: EPriceType.SM },
];

const RENT_OPTIONS: ISelectOption[] = [
  { label: 'за месяц', value: EPriceType.Total },
  { label: 'за м\u00B2 в год', value: EPriceType.SM },
];

export const selectCommercialPriceTypeOptions = createSelector(
  [selectDealType, selectOfferType],
  (dealType, offerType) => {
    if ((offerType & COWORKING_AND_WORKPLACE) !== 0) {
      return COWORKING_OPTIONS;
    }

    if ((offerType & FOfferType.CommercialLand) !== 0) {
      return (dealType & FDealType.Sale) !== 0 ? SALE_LAND_OPTIONS : RENT_LAND_OPTIONS;
    }

    return (dealType & FDealType.Sale) !== 0 ? SALE_OPTIONS : RENT_OPTIONS;
  },
);
